var pageIndex = {
  setCondition: function (){
    window.cateData.api.getItemCondition = 'index';
  },

  init: function(){
    this.setCondition();
  }
};

//登录文字抖动
$('.caution').click(function () {
    $('.shakeBg').addClass('shake shake-horizontal');

    //抖一下
    setTimeout(function(){
        $('.shakeBg').removeClass('shake shake-horizontal');
    }, 500);
});

// $('.caution').hover(function () {
//     $('.shakeBg').addClass('shake shake-horizontal');
// },function () {
//     $('.shakeBg').removeClass('shake shake-horizontal');
// });